import * as Yup from 'yup'

export const ValidationSchema = Yup.object().shape({
  name: Yup.string().required("Campo requerido"),
  description: Yup.string().nullable(),
  footer: Yup.string().nullable(),
  icon: Yup.string().nullable(),
  image: Yup.mixed().when('showImage', {
    is: true,
    then: Yup.mixed()
    .test("type", "Solo imagenes", (value) => {
      console.log("Validation imageActive", value)
      if (value === "" || value === null || value === undefined) {
        console.log("Validation imageActive 1", value)
        return true
      }
      var regex = /^\w{8}-\w{4}-\w{4}-\w{4}-\w{12}$/;
      if (regex.test(value)) {
        return true
      }
      return Array.isArray(value) && value.length > 0 && value[0].type.includes("image")

    }),
    otherwise: Yup.mixed().nullable()
  }),
  video: Yup.string().when('showVideo', {
    is: true,
    then: Yup.string().required("Campo requerido"),
    otherwise: Yup.string().nullable()
  }),
  category: Yup.string().required("Campo requerido"),
  showName: Yup.boolean().nullable(),
  showImage: Yup.boolean().nullable(),
  showVideo: Yup.boolean().nullable(),
  presentation: Yup.number().required(),
  active: Yup.boolean().required("Campo requerido"),
})

// Columns Validations
export const ValidationSchemaColumn = Yup.object().shape({
  title: Yup.string().required("Campo requerido"),
  icon: Yup.string().when('showIcon', {
    is: true,
    then: Yup.string().required("Campo requerido"),
    otherwise: Yup.string().nullable()
  }),  
  showTitle: Yup.boolean().nullable(),
  showIcon: Yup.boolean().nullable(),
  active: Yup.boolean().required("Campo requerido")
})

export const ValidationSchemaColumns = Yup.object({
  variants: Yup.array().of(
    Yup.object().shape({
      title: Yup.string().required("Campo requerido"),
      icon: Yup.string().when('showIcon', {
        is: true,
        then: Yup.string().required("Campo requerido"),
        otherwise: Yup.string().nullable()
      }),  
      showTitle: Yup.boolean().nullable(),
      showIcon: Yup.boolean().nullable(),
      active: Yup.boolean().required("Campo requerido")
    })
  )
})